module.exports = __webpack_public_path__ + "media/init_hp.6eb9972c.mp3";